module.exports = __webpack_public_path__ + "img/12_icon_right_arrow_line@3x.e0faa60d.png";